import styled from "styled-components";
import { P } from "@nested/nested-react-components";

const HeroSubtitle = styled(P)`
  text-align: center;
  ${(props) => props.white && `color: ${props.theme.colors.greys.white}`};
  ${(props) => props.bold && `font-weight: ${props.theme.font.bold}`};

  a {
    font-size: ${(props) => props.theme.font.size.default};
    line-height: ${(props) => props.theme.font.lineHeight.default};
    text-align: center;
  }
`;

HeroSubtitle.displayName = "HeroSubtitle";

export { HeroSubtitle };
